import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";


const OperationalWiseMIS = () => {
  const [datelist, setDatelist] = useState([]);

  const FillDetail = () => {
    const Datelst = [
      { name: "Lot Creation", reportUrl: "/lotcreationreport", icon: "fa-layer-group" },
      { name: "Cleaning & Washing", reportUrl: "/cleaningwashingreport", icon: "fa-soap" },
      { name: "Sorting & Grading", reportUrl: "/sortinggradingreport", icon: "fa-sort-amount-up-alt" },
      { name: "Packaging & Labelling", reportUrl: "/packaginglabellingreport", icon: "fa-tags" },
      { name: "Pallet Detail", reportUrl: "/palletdetailreport", icon: "fa-boxes" },
      { name: "Precooling Detail", reportUrl: "/precoolingdetailreport", icon: "fa-snowflake" },
      { name: "Controlled Atmosphere Detail", reportUrl: "/controlledatmospherereport", icon: "fa-wind" },
      { name: "Container Loading Detail", reportUrl: "/containerloadingreport", icon: "fa-truck-loading" },
      { name: "Delivery Dispatch Detail", reportUrl: "/deliverydispatchreport", icon: "fa-shipping-fast" },
      { name: "Gatepass Detail", reportUrl: "/gatepassdetailreport", icon: "fa-id-badge" },
      { name: "Fuel Details", reportUrl: "/fueldetailreport", icon: "fa-gas-pump" },
      { name: "Goods Productwise Issued Detail", reportUrl: "/goodsProductIssue", icon: "fa-box-open" },
      { name: "Inventory Transaction Report", reportUrl: "/inventoryTransaction", icon: "fa-sync-alt" },
    ];
    setDatelist(Datelst);
  };

  useEffect(() => {
    FillDetail();
  }, []);

  const colors = [
    "#00acc1", "#e53935", "#43a047", "#fbc02d", "#5e35b1",
    "#fb8c00", "#039be5", "#8d6e63", "#3949ab", "#6d4c41",
    "#00897b", "#c2185b", "#7cb342"
  ];

  return (
    <div className="content-wrapper p-4">
      <h4 className="mb-4 text-primary">⚙️ Operational Report Dashboard</h4>

      <div className="row">
        {datelist.map((item, index) => (
          <div className="col-md-4 mb-3" key={index}>
            <Link to={item.reportUrl} className="text-decoration-none">
              <div
                className="report-box d-flex align-items-center shadow-sm p-3 rounded"
                style={{
                  borderLeft: `10px solid ${colors[index % colors.length]}`,
                  backgroundColor: "#fff",
                }}
              >
                <div
                  className="icon-circle d-flex justify-content-center align-items-center mr-3"
                  style={{
                    backgroundColor: colors[index % colors.length],
                    color: "white",
                  }}
                >
                  <i className={`fas ${item.icon}`} />
                </div>
                <div className="report-name text-dark font-weight-bold">{item.name}</div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <style>{`
        .report-box {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border-radius: 12px;
        }
        .report-box:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
        }
        .icon-circle {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          font-size: 18px;
          flex-shrink: 0;
        }
        .report-name {
          font-size: 15px;
          line-height: 1.3;
        }
      `}</style>
    </div>
  );
};

export default OperationalWiseMIS;
